import { jsx as _jsx } from "react/jsx-runtime";
import { RadioGroup } from "../radio";
import { cn } from "../utils";
import { mfaFactorOptionTestId } from "./mfaFactorOptionTestId";
const DEFAULT_NAME = "mfa-factor";
/**
 * MFA factor selection UI: vertical radio list with no i18n or domain logic.
 * Pass pre-formatted `label` strings from your app’s translation/formatting layer.
 */
export function MFAFactorSelector({ factors, selectedFactorId, onSelect, disabled = false, name = DEFAULT_NAME, className, style: _style, }) {
    const handleChange = (factorId) => {
        const factor = factors.find((f) => f.id === factorId);
        if (factor) {
            onSelect(factor);
        }
    };
    return (_jsx("div", { className: cn("mfa-factor-selector mb-7 md:mb-8", className), children: _jsx(RadioGroup, { name: name, value: selectedFactorId, onChange: handleChange, orientation: "vertical", disabled: disabled, disableDefaultGap: true, children: factors.map((factor) => (_jsx(RadioGroup.Item, { value: factor.id, label: factor.label, disabled: factor.disabled, testID: factor.testID ?? mfaFactorOptionTestId(factor.id) }, factor.id))) }) }));
}
//# sourceMappingURL=MFAFactorSelector.js.map